<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">404</h1>
          <h4 class="pt-3">Resource Not Found.</h4>
          <p class="text-muted">The resource you are looking for was not found or the link expired.</p>
        </div>        
      </div>
    </div>
  </div>
</div>
